<template>
  <div class="checkbox-filter">
    <b-form-group>
      <b-form-checkbox-group
        :name="`checkbox_${attrCode}`"
        v-model="selected"
        :options="mapOptions"
        class="single-item"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    attrCode: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    mapOptions () {
      const _this = this
      if (this.attrCode && this.options) {
        return this.sortFilterValues(this.options.map(opt => ({
          value: opt.value,
          html: _this.optionLabel(this.attrCode, opt)
        })))
      }
      return []
    },
    selected: {
      get () {
        return this.attrCode && this.$store.state.listing.filters.chosen[this.attrCode]
          ? this.$store.state.listing.filters.chosen[this.attrCode]
          : []
      },
      set (newValues) {
        this.$store.commit('listing/updateTemporaryFilters', this.getFilterCompose(newValues))
        return newValues
      }
    }
  },
  methods: {
    getFilterCompose (newValues) {
      return { attrCode: this.attrCode, valueSelected: newValues }
    },
    optionLabel (attrCode, opt) {
      return ['0', '1'].includes(opt.label) ? opt.label === opt.value ? this.$t('label_' + opt.label) : opt.label : opt.label
    },
    sortFilterValues (options) {
      let notCastableValues = []
      if (this.attrCode === 'size') {
        // cast all size value from String to Int, if value is not castable remove from array and push after sort
        options = options.map(function (opt, index) {
          if (!isNaN(parseInt(opt.html))) {
            return {
              ...opt,
              html: parseInt(opt.html)
            }
          } else {
            notCastableValues.push(opt)
          }
        })
        options = options.sort((a, b) => {
          return a.html - b.html
        })
      }
      // remove undefined || null after merge of array
      return [...options, ...notCastableValues].filter(obj => obj)
    }
  }
}
</script>
